import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../firebase";
import { doc, setDoc } from "firebase/firestore";

export default function SetUsername() {
  const [username, setUsername] = useState("");
  const navigate = useNavigate();

  const handleSave = async () => {
    const trimmed = username.trim();
    if (!trimmed) {
      alert("Username cannot be empty");
      return;
    }

    try {
      const user = auth.currentUser;
      if (user) {
        const userRef = doc(db, "users", user.uid);
        await setDoc(userRef, {
          uid: user.uid,
          email: user.email,
          username: trimmed,
          followers: [],
          following: [],
          privacy: "public" // optional: used in settings
        });
        navigate("/feed");
      } else {
        alert("Not authenticated");
      }
    } catch (err) {
      alert("Error saving username: " + err.message);
    }
  };

  return (
    <div style={{ padding: "20px", maxWidth: "400px", margin: "auto" }}>
      <h2>Set Your Username</h2>
      <input
        type="text"
        placeholder="Enter a username"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        style={{ width: "100%", padding: "10px", marginBottom: "10px" }}
      />
      <button onClick={handleSave} style={{ padding: "10px 20px" }}>
        Save
      </button>
    </div>
  );
}
